import Checkbox from './Checkbox.vue'

export { Checkbox }
export default Checkbox
